// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale'

// import VueIntercom from 'vue-intercom'

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/app.less'

import WpButton from './components/WpButton'
import WpInput from './components/WpInput'
import WpMandyMini from './components/WpMandyMini'

import i18n from './locales/i18n'

// Vue.use(VueIntercom, { appId: 'hd46brwk' }) // 测试classover2
// Vue.use(VueIntercom, { appId: 'ysd0hi0c' }) // 生产

// Vue.use(ElementUI, { locale })
Vue.use(ElementUI)
Vue.config.productionTip = false

console.log('version---')
console.log(Vue.version)

Vue.component('wp-button', WpButton)
Vue.component('wp-input', WpInput)
Vue.component('wp-mandy-mini', WpMandyMini)

// localStorage.clear();
// sessionStorage.clear();

/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n,
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js